import React from 'react';
import { Box } from '@mui/material';
import { helix } from 'ldrs';
import { themeObject } from 'lib';

helix.register();

const loaderStyles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
};

export const HelixLoader = (): React.JSX.Element => {
    return (
        <Box sx={loaderStyles} data-testid='helix-loader'>
            <l-helix
                color={themeObject.palette.tertiary.purple[500]}
                size={60}
            />
        </Box>
    );
};
